import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedSection, {
  staggerContainer,
  fadeUpVariant,
} from "../components/AnimatedSection";
import LearnMoreArrowIcon from "../components/LearnMoreArrowIcon";
import "./InnerPage.scss";

const stages = [
  {
    step: "01",
    title: "Submit Shipment Request",
    what: "A trader, broker, or buyer submits a shipment request with route details, cargo, and counterparty info.",
  },
  {
    step: "02",
    title: "Finance & Monitor Execution",
    what: "OneLedger reviews the corridor, deploys capital, and monitors the shipment from origin to destination. We manage counterparty risk end-to-end.",
  },
  {
    step: "03",
    title: "Settle on Delivery",
    what: "On confirmed delivery, payment is triggered automatically. All parties — traders, brokers, and drivers — are settled promptly.",
  },
];

export default function HowItWorksPage() {
  return (
    <>
      <Navbar />
      <main className="inner-page inner-page--how-it-works">
        <section className="inner-page__hero">
          <div className="container">
            <AnimatedSection className="inner-page__hero-content">
              <p className="inner-page__label">The Process</p>
              <h1 className="inner-page__title">How OneLedger Works</h1>
              <p className="inner-page__sub">
                Three steps that convert fragmented freight flows into a funded,
                tracked, and settled trade — every time.
              </p>
            </AnimatedSection>
          </div>
        </section>

        <section className="inner-page__section">
          <div className="container">
            <motion.div
              className="hiw-stages"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
            >
              {stages.map(({ step, title, what }) => (
                <motion.div
                  key={step}
                  className="hiw-stage"
                  variants={fadeUpVariant}
                >
                  <div className="hiw-stage__aside">
                    <div className="hiw-stage__step">{step}</div>
                  </div>
                  <div className="hiw-stage__body">
                    <h2 className="hiw-stage__title">{title}</h2>
                    <p className="hiw-stage__desc">{what}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        <section className="inner-page__section inner-page__section--dark">
          <div className="container">
            <AnimatedSection className="inner-page__split">
              <div>
                <p className="inner-page__label--white">Who Benefits</p>
                <h2 className="inner-page__title--white">
                  Everyone in the value chain wins
                </h2>
              </div>
              <div className="inner-page__benefit-grid">
                {[
                  {
                    role: "Traders",
                    benefit: "Capital on day one. No waiting.",
                  },
                  {
                    role: "Brokers",
                    benefit: "Reliable loads, faster settlement.",
                  },
                  {
                    role: "Buyers",
                    benefit: "Payment only on delivery confirmation.",
                  },
                  { role: "Drivers", benefit: "Faster pay, less friction." },
                ].map(({ role, benefit }) => (
                  <div key={role} className="inner-page__benefit">
                    <span className="inner-page__benefit-role">{role}</span>
                    <p className="inner-page__benefit-text">{benefit}</p>
                  </div>
                ))}
              </div>
            </AnimatedSection>
          </div>
        </section>

        <section className="inner-page__section inner-page__section--cta">
          <div className="container inner-page__cta">
            <AnimatedSection>
              <h2 className="inner-page__cta-title">
                Ready to start a conversation?
              </h2>
              <Link to="/contact" className="btn-learn-more">
                Get In Touch
                <LearnMoreArrowIcon />
              </Link>
            </AnimatedSection>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
